import { render, staticRenderFns } from "./reset_email.vue?vue&type=template&id=28cb5d28&scoped=true"
import script from "./reset_email.vue?vue&type=script&lang=js"
export * from "./reset_email.vue?vue&type=script&lang=js"
import style0 from "./reset_email.vue?vue&type=style&index=0&id=28cb5d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cb5d28",
  null
  
)

export default component.exports